export function isPlannerGroup(item = {}) {
  return Boolean(item?.isGroup);
}

export function plannerCountableItems(items = []) {
  return (Array.isArray(items) ? items : []).filter((item) => item && typeof item === "object" && !isPlannerGroup(item));
}

export function isQuestionGroup(item = {}) {
  return Boolean(item?.isGroup);
}

export function questionLeafRecords(items = []) {
  return (Array.isArray(items) ? items : []).filter((item) => item && !isQuestionGroup(item));
}

export function questionTopLevelItems(items = []) {
  return (Array.isArray(items) ? items : []).filter((item) => !String(item.questionGroupId || "").trim());
}

export function questionsForMetrics(items = []) {
  return questionLeafRecords(items);
}
